import React, { useState, useEffect } from "react";
import axios from "axios";

// Components
import Preloader from "../../../components/Preloader/Preloader";

import MUIDataTable from "mui-datatables";

//Date Range
import { addDays, format } from "date-fns";
import { DateRangePicker } from "materialui-daterange-picker";
import { NavLink } from "react-router-dom";
// Material UI Component
import {
  FormGroup,
  FormLabel,
  FormControl,
  // ListItemText,
  TextField,
  // Checkbox,
  // FormControlLabel,
  Grid,
  Select,
  InputLabel,
  Input,
  // MenuItem,
  Modal,
  Backdrop,
  Fade,
  FormHelperText,
  NativeSelect,
  Button,
  Breadcrumbs,
  Typography,
} from "@material-ui/core";
import {
  makeStyles,
  createMuiTheme,
  MuiThemeProvider,
} from "@material-ui/core/styles";

// Material Icons
import { AssessmentTwoTone } from "@material-ui/icons";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";
//cookies
import { get_cookies } from "../../../components/Cookies/Cookies";
import numeral from "numeral";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
}));

const ProductPackage = () => {
  const [uniqueID, setUniqueId] = useState("");
  const [posts, setPosts] = useState([]);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [open, setOpen] = useState(false);
  const [downloadFlag, setDownloadFlag] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [dateRange, setDateRange] = useState({
    startDate: new Date(),
    endDate: addDays(new Date(), 7),
  });
  const classes = useStyles();

  const [useridNo, setuseridNo] = useState(get_cookies("branchidno"));
  // console.log(uniqueID);
  // Data Fetching
  useEffect(() => {
    data();
    dataFilter();
  }, []);

  useEffect(() => {
    if (posts.length > 0) {
      setDownloadFlag(true);
    } else {
      setDownloadFlag(false);
    }
  }, [posts]);
  //search button
  const dataFilter = async () => {
    setDataLoaded(false);
    await axios
      .get(process.env.REACT_APP_API_URL + "get_productPackage", {
        params: {
          jc_user_id_no: useridNo,
        },
      })
      .then((res) => {
        console.log("12", res);
        setPosts(res.data.data);
      })
      .catch((error) => {
        // console.log(error.message);
      });
    setDataLoaded(true);
  };

  const data = async () => {
    setDataLoaded(true);
  };

  const toggle = () => setOpen(!open);

  const handleModalOpen = () => {
    setModalOpen(true);
  };

  const handleModalClose = () => {
    setModalOpen(false);
  };

  const dateRangeHandler = (range) => {
    setDateRange(range);
    setOpen(false);
  };
  const columns = [
    {
      name: "id",
      label: "ID",
    },
    {
      name: "description",
      label: "Name",
    },
    {
      name: "action",
      label: "Action",
      options: {
        download: false, //exclude this column in csv export
        sort: false,
        filter: false,
        customBodyRenderLite: (dataIndex) => {
          let id = posts[dataIndex].id;
          let status = posts[dataIndex].status;
          // collectionviewdetails
          // collectionallocate
            return (
              <Grid container spacing={1}>
                <Grid item xs={12} sm={12} md={12} lg={5} xl={4}>
                  <NavLink
                    to={"/settings/product-package-view/" + id}
                  >
                    <Button variant="contained" color="primary">
                      View
                    </Button>
                  </NavLink>
                </Grid>
              </Grid>
            );

        },
      },
    },
  ];

  const options = {
    filter: false,
    // filterType: "dropdown",
    selectableRows: "none",
    filterType: "multiselect",
    responsive: "standard",
    download: false, //add this
    print: false, //add this
    viewColumns: false,
    setFilterChipProps: (colIndex, colName, data) => {
      //console.log(colIndex, colName, data);
      return {
        color: "primary",
        variant: "outlined",
        className: "testClass123",
      };
    },
    downloadOptions: {
      filename: "CollectionTransactionHistory.csv", //change filename of csv
    },
    // tableBodyHeight,
  };

  const style = {
    marginBottom: "1rem",
    marginTop: "2.5em",
  };

  return (
    <div className="page">
      <div className="page-header">
        <div className="page-icon">
          <ShoppingCartIcon />
        </div>
        <Breadcrumbs aria-label="breadcrumb">
          <NavLink to="/settings">
            <h2 className="header-title">Settings</h2>
          </NavLink>
          <Typography color="textPrimary">Product Package</Typography>
        </Breadcrumbs>
      </div>
      <div className="page-container">
        {/* <div style={style}>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={4} md={4} lg={3} xl={2}>
              <TextField
                id="outlined-basic"
                label="Select Date"
                variant="outlined"
                onFocus={() => setOpen(true)}
                fullWidth={true}
                autoComplete="off"
                value={`${format(dateRange.startDate, "MM/dd/yyyy")} - ${format(
                  dateRange.endDate,
                  "MM/dd/yyyy"
                )}`}
              />
              <DateRangePicker
                open={open}
                toggle={toggle}
                onChange={(range) => dateRangeHandler(range)}
              />
            </Grid>
            <Grid item xs={12} sm={4} md={4} lg={3} xl={2}>
              <TextField
                id="outlined-search"
                label="Search by ID"
                type="search"
                variant="outlined"
                value={uniqueID}
                onChange={(e) => {
                  setUniqueId(e.target.value);
                }}
              />
            </Grid>
            <Grid item xs={4} lg={1} xl={1}>
              <Button
                variant="contained"
                style={{ marginTop: "23px" }}
                color="primary"
                onClick={() => {
                  dataFilter();
                }}
              >
                Search
              </Button>
            </Grid>
          </Grid>
        </div> */}

        {!dataLoaded ? (
          <Preloader />
        ) : (
          <MUIDataTable
            title={
              <div>
                <h3 className="header-title" style={{ color: "#339933" }}>
                  Product Package
                </h3>
              </div>
            }
            data={posts}
            columns={columns}
            options={options}
          />
        )}
      </div>
    </div>
  );
};

export default ProductPackage;
